var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import Model from './Model';
var TABLE_MODEL_STORAGE_NAME = 'TableModel';
var TableModel = /** @class */ (function (_super) {
    __extends(TableModel, _super);
    function TableModel() {
        var _this = _super.call(this) || this;
        var storedData = localStorage.getItem(TABLE_MODEL_STORAGE_NAME);
        if (storedData) {
            try {
                _this.update(JSON.parse(storedData));
            }
            catch (e) {
            }
        }
        return _this;
    }
    TableModel.prototype.updateCache = function () {
        localStorage.setItem(TABLE_MODEL_STORAGE_NAME, JSON.stringify(this));
    };
    __decorate([
        observable
    ], TableModel.prototype, "compact", void 0);
    return TableModel;
}(Model));
export default TableModel;
